@if (insurants && insurantsFormConfig) {
    <div class="clearfix"></div>

    @for (insurantConfig of insurantsFormConfig.insurants; track $index; let $i = $index) {
        @if (!hideInsurantsFor(insurantConfig)) {
            <div [ngClass]="{ 'm-12:t md:m-16:t lg:m-24:t': $i > 0 }">
                @if (insurantsFormConfig.insurants.length > 1) {
                    <small>
                        <strong>{{ insurantConfig.displayNameSummary || insurantConfig.displayName }}</strong>
                    </small>
                }

                @if (getInsurantsByCategory(insurantConfig.category); as insurants) {
                    @for (insurant of insurants; track insurant) {
                        <div class="m-6:t md:m-8:t lg:m-12:t">
                            <small>
                                @if (insurantConfig.askForTitle && insurant.title) {
                                    <span>{{ insurant.title.description }}</span>
                                }
                                {{ insurant.firstName }} {{ insurant.lastName }}
                            </small>
                            <dl class="clearfix">
                                <dt>Geb. am.:</dt>
                                <dd>{{ insurant.dateOfBirth }}</dd>
                            </dl>
                            @if (insurantConfig.insuranceRanks) {
                                <dl class="clearfix">
                                    <dt>Tarif:</dt>
                                    <dd>{{ getInsuranceRank(insurant.insuranceRankId, insurantConfig) }}</dd>
                                </dl>
                            }
                            @if (insurantConfig.askForHealthInsurance) {
                                <dl class="clearfix">
                                    <dt>Krankenversicherung:</dt>
                                    <dd>{{ insurant.healthInsurance }}</dd>
                                </dl>
                            }
                        </div>
                    } @empty {
                        <div class="m-6:t md:m-8:t lg:m-12:t">
                            <small>keine</small>
                        </div>
                    }
                }
            </div>
        }
    }
}
